import React from 'react';

interface ClockSmallIconProps {
  size?: number;
  color?: string;
}

export const ClockSmallIcon: React.FC<ClockSmallIconProps> = ({ 
  size = 14, 
  color = '#6e6e6e' 
}) => {
  const clipId = React.useId();
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 14 14"
    >
      <g clipPath={`url(#${clipId})`}>
        <path 
          stroke={color} 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="1.143" 
          d="M6.856 3.428v3.428L9.142 8m3.428-1.143a5.714 5.714 0 1 1-11.427 0 5.714 5.714 0 0 1 11.427 0"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <path fill="#fff" d="M0 0h13.713v13.713H0z"/>
        </clipPath>
      </defs>
    </svg>
  );
};

